<script setup>

const props = defineProps({
	settings: {
		type: Object, // this will actually be an InertiaForm object
		required: true,
	},
})

const emit = defineEmits(['update:xero-settings'])

function save() {
	emit('update:xero-settings', props.settings)
}

</script>

<template>
	<form @submit.cancel.prevent="save">
		<Input
			v-model="settings.payments_account_code"
			:errors="settings.errors.payments_account_code"
			label="Payments Account Code"
			placeholder="eg: 090"
			helpText="The Xero account code to use for payments. You can find this in your Xero account under Accounting > Advanced > Chart of accounts."
			testid="payments-account-code-input"
			@keyup.enter="save"
		/>
	</form>
</template>